export const LOAD_ROOM_LIST = "[BOOKINGADMIN] LOAD_ROOM_LIST";

export const LOAD_BUILDING_LIST = "[BOOKINGADMIN] LOAD_BUILDING_LIST";

export const LOAD_ADDREASON_LIST = "[BOOKINGADMIN] LOAD_ADDREASON_LIST";

export const LOAD_FLOORS_LIST = "[BOOKINGADMIN] LOAD_FLOORS_LIST";

export const SET_SITE_ID = "[BOOKINGADMIN] SET_SITE_ID";

export const LOAD_SITES_LIST = "[BOOKINGADMIN] LOAD_SITES_LIST";

// Unique action types for admin location data
export const SET_ADMIN_SITE_ID = "[BOOKINGADMIN] SET_ADMIN_SITE_ID";
export const LOAD_ADMIN_BUILDINGS = "[BOOKINGADMIN] LOAD_ADMIN_BUILDINGS";
export const LOAD_ADMIN_FLOORS = "[BOOKINGADMIN] LOAD_ADMIN_FLOORS";
export const LOAD_ADMIN_ROOMS = "[BOOKINGADMIN] LOAD_ADMIN_ROOMS";

// Booking approval action type
export const APPROVE_BOOKING = "[BOOKINGADMIN] APPROVE_BOOKING";

// Booking rejection action type
export const REJECT_BOOKING = "[BOOKINGADMIN] REJECT_BOOKING";

// Filtered instrument list loading
export const SET_LOADING_INSTRUMENTS = "[BOOKINGADMIN] SET_LOADING_INSTRUMENTS";
export const LOAD_FILTERED_INSTRUMENTS = "[BOOKINGADMIN] LOAD_FILTERED_INSTRUMENTS";
export const SET_INSTRUMENTS_ERROR = "[BOOKINGADMIN] SET_INSTRUMENTS_ERROR";
